import {combineReducers} from 'redux';

import {toasterReducers} from '@homeaway/react-toaster';
import {tripboardButtonReducer} from '@homeaway/react-trip-board-button';

import config from './config';
import content from './content';
import destination from './destination';
import greatPlaces from '../modules/GreatPlacesToStay/redux';
import modules from './modules';
import propertyTypes from '../modules/PropertyTypes/redux';
import search from './search';
import seoLinkpile from './seo-linkpile';
import pointsOfInterest from '../modules/PointsOfInterest/redux';
import urgencyDestination from '../modules/UrgencyMessage/redux';
import trustpilotReducer from '../modules/Trustpilot/redux';
import {moduleStatus} from './moduleStatus';

// NOTE: the `takeNoAction` function is a convenience for accessing data
// it SHOULD NOT be used; you can replace it with Context instead
// see here for Context docs: https://reactjs.org/docs/context.html
function takeNoAction(state) {
    return state || {};
}

export const reducers = combineReducers({
    abacus: takeNoAction,
    config,
    options: takeNoAction,
    content,
    destination,
    error: takeNoAction,
    pointsOfInterest,
    greatPlaces,
    mab: takeNoAction,
    modules,
    propertyTypes,
    search,
    seoLinkpile,
    siteContext: takeNoAction,
    toaster: toasterReducers,
    tripboardButton: tripboardButtonReducer,
    urgencyDestination,
    globalMessages: takeNoAction,
    trustpilot: trustpilotReducer,
    moduleStatus,
});

export default reducers;
